import CacheEnabledApiClient from './CacheEnabledApiClient';

class TopicLabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('topic_labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'topic_label';
  }
}

export default new TopicLabelsAPI();

